import KakaoMap from './KakaoMap';
export default KakaoMap;
